"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppPageArtworkItem = void 0;
const is_plain_object_1 = __importDefault(require("./is-plain-object"));
/**
 * Returns the first item on an app page that has artwork. This utility is used
 * when we need a representative image for a page.
 */
function getAppPageArtworkItem({ pageId, manifest, }) {
    const page = pageId !== undefined
        ? manifest === null || manifest === void 0 ? void 0 : manifest.pages.find((page) => page.id === pageId)
        : undefined;
    const modules = page === null || page === void 0 ? void 0 : page.moduleIds.map((id) => manifest === null || manifest === void 0 ? void 0 : manifest.modules.find((module) => module.id === id)).filter((module) => Boolean(module));
    return getFirstItemWithArtwork(modules);
}
exports.getAppPageArtworkItem = getAppPageArtworkItem;
function getFirstItemWithArtwork(value) {
    if ((0, is_plain_object_1.default)(value)) {
        if ("imageUrl" in value && typeof value.imageUrl === "string") {
            return { type: "url", url: value.imageUrl };
        }
        else if ("contentId" in value && typeof value.contentId === "number") {
            return { type: "content", id: value.contentId };
        }
        else if ("collectionId" in value &&
            typeof value.collectionId === "number") {
            return { type: "collection", id: value.collectionId };
        }
        else {
            for (const v of Object.values(value)) {
                const item = getFirstItemWithArtwork(v);
                if (item) {
                    return item;
                }
            }
        }
    }
    if (Array.isArray(value)) {
        for (const v of value) {
            const item = getFirstItemWithArtwork(v);
            if (item) {
                return item;
            }
        }
    }
    return null;
}
